import { render, staticRenderFns } from "./FeatureImage.vue?vue&type=template&id=fb0d028a&"
import script from "./FeatureImage.vue?vue&type=script&lang=js&"
export * from "./FeatureImage.vue?vue&type=script&lang=js&"
import style0 from "./FeatureImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports